var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSlightlyImportant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0625 15.75C29.0625 10.7695 26.3672 6.14062 22.0312 3.62109C17.6367 1.10156 12.3047 1.10156 7.96875 3.62109C3.57422 6.14062 0.9375 10.7695 0.9375 15.75C0.9375 20.7891 3.57422 25.418 7.96875 27.9375C12.3047 30.457 17.6367 30.457 22.0312 27.9375C26.3672 25.418 29.0625 20.7891 29.0625 15.75ZM0 15.75C0 10.418 2.8125 5.49609 7.5 2.80078C12.1289 0.105469 17.8125 0.105469 22.5 2.80078C27.1289 5.49609 30 10.418 30 15.75C30 21.1406 27.1289 26.0625 22.5 28.7578C17.8125 31.4531 12.1289 31.4531 7.5 28.7578C2.8125 26.0625 0 21.1406 0 15.75Z",
    fill: "#0D63CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSlightlyImportant);
export default __webpack_public_path__ + "static/media/icon_slightly_important.586877449fd3250cfa596ea288126e00.svg";
export { ForwardRef as ReactComponent };